import React from "react";
import {Redirect, Route} from "react-router-dom";
import {useAppContext} from "../libs/ContextLibs";
import {querystring} from "./Util";


export default function UnauthenticatedRoute({children, ...rest}) {
    const {isAuthenticated} = useAppContext();
    const redirect = querystring("redirect");
    return (
        <Route {...rest}>
            {!isAuthenticated ? (
                children
            ) : (
                <Redirect to={redirect === "" || redirect === null ? "/" : redirect}/>
            )}
        </Route>
    );
}